import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";
import $ from "jquery";

function* execute(action: sage.actions.team.ICreateTeamInvite) {
    yield put({
        type: "com.sage.actions.teams.ISetCreateTeamInviteStatus",
        status: "loading",
    } as sage.actions.team.ISetCreateTeamInviteStatus);
    try {
        yield post("/create-team-invite", {
            team_id: action.teamId,
            email: action.email,
        });
        yield put({
            type: "com.sage.actions.team.IFetchTeamInivitees",
            teamId: action.teamId,
        } as sage.actions.team.IFetchTeamInivitees);
        yield put({
            type: "com.sage.actions.teams.ISetCreateTeamInviteStatus",
            status: "loading",
        } as sage.actions.team.ISetCreateTeamInviteStatus);
        ($("#addMemberModal") as any).modal("hide");
    } catch (e) {
        yield handleNetworkError(e);
        yield put({
            type: "com.sage.actions.teams.ISetCreateTeamInviteStatus",
            status: "loading",
        } as sage.actions.team.ISetCreateTeamInviteStatus);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.team.ICreateTeamInvite", execute);
}
